module.exports = __webpack_public_path__ + "media/images/logo-sutcobao-0a45087b1dc1352af961bfaa354bf7af.svg";